export * from './NewsletterConfigRepository';
